/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningCircleIcon16Solid = forwardRef('WarningCircleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-5.873 3a1.127 1.127 0 1 1-2.254 0 1.127 1.127 0 0 1 2.254 0ZM9 4.5a1 1 0 1 0-2 0v3.25a1 1 0 0 0 2 0V4.5Z" })));
});
